import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Overlay = styled(Box)(({ theme }) => (`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${theme.components.LoaderDots.styleOverrides.overlayBackground};
`))

export const ServerContentLoader = styled(Box)(({ theme }) => (`
    height:40px;
    width:40px;

    &.load-3 .line:nth-last-of-type(1) { animation: loadingC 0.6s 0.1s linear infinite; }
    &.load-3 .line:nth-last-of-type(2) { animation: loadingC 0.6s 0.2s linear infinite; margin:0 3px; }
    &.load-3 .line:nth-last-of-type(3) { animation: loadingC 0.6s 0.3s linear infinite; }
  
    @keyframes loadingC {
        0 { transform: translate(0, 0); }
        50% { transform: translate(0, 15px); }
        100% { transform: translate(0, 0); }
    } 
  
    & .line {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background-color: ${theme.components.LoaderDots.styleOverrides.dotColor};
        opacity:0.5;
    }
    
    &.sm {
        height:30px !important;
        width:30px !important;
        & .line {
            width: 7px !important;
            height: 7px !important;
        }
    }

`))
